import React, { FormHTMLAttributes } from 'react'
import { Text, TextProps, Flex, FlexProps } from '@clear/design-system'

type FormProps = FlexProps & FormHTMLAttributes<HTMLFormElement>

export const Form: React.FC<FormProps> = (props) => (
  <Flex as="form" flexDirection="column" {...props} />
)

export const Row: React.FC<FlexProps> = (props) => (
  <Flex
    flexDirection={['column', 'row']}
    alignItems={['stretch', 'flex-start']}
    mx={-4}
    {...props}
  />
)

export const Actions: React.FC<FlexProps> = (props) => (
  <Flex mt={6} justifyContent="space-between" {...props} />
)

export const StepTitle: React.FC<TextProps> = (props) => (
  <Text
    as="h1"
    textAlign="center"
    color="brandDarkBlue"
    variant="display"
    fontSize={5}
    mt={7}
    mb={3}
    {...props}
  />
)

export const StepSubTitle: React.FC<TextProps> = (props) => (
  <Text as="p" textAlign="center" color="neutralsTextGray" my={2} {...props} />
)

export const ErrorMessage = React.forwardRef<HTMLDivElement, TextProps>(
  ({ children, ...props }, ref) => (
    <Text
      as="div"
      color="utilityDarkErrorRed"
      textAlign="center"
      mt={6}
      data-cy="global-error"
      ref={ref}
      {...props}
    >
      Error: {children}
    </Text>
  )
)

ErrorMessage.displayName = 'ErrorMessage'
